import Ajax from '@utils/ajax';

export default {
  create(data, options = {}) {
    return Ajax.post({
      url: `/reports`,
      data: data,
      ...options,
    });
  },

  delete(id, options = {}) {
    return Ajax.post({
      url: `/reports/${id}`,
      data: {
        _method: 'DELETE',
      },
      ...options,
    });
  },
};
